import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProcessoCartaCreditoService } from '../service/processo-carta-credito.service';
import { ProcessoCartaCreditoFinanceiro } from '../shared/model/processo-carta-credito-financeiro.model';
import { SecurityService } from '../service/security.service';

@Injectable({
  providedIn: 'root'
})
export class CartaCreditoGuard implements CanActivate {

  constructor(private readonly router: Router,
              private readonly processoCartaService: ProcessoCartaCreditoService,
              private readonly securityService: SecurityService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable(subscriber => {
      if(this.securityService.usuarioSessao) {
        this.processoCartaService.obterProcessoCartaCredito().subscribe(
          (processoCartaCredito: ProcessoCartaCreditoFinanceiro) => {
              if(processoCartaCredito != null) {
                subscriber.next(true);
                subscriber.complete();
              } else {
                this.router.navigate(['/termo-carta-credito']).then(() => {
                  subscriber.next(false);
                  subscriber.complete();
                });
              }
            }
          )
      }
    });
  }
}
